export const getTotalSupply =
`
import BottomShot from 0x0891c3a59894a20c;

pub fun main(): UInt64 {

    return BottomShot.totalSupply;

}
`